import { TermsContactEmail } from "./-terms.contact";
import type { TermsSectionContent } from "./-terms.sections";

export const TERMS_CLOSING_SECTIONS: TermsSectionContent[] = [
  {
    title: "11. Governing law",
    blocks: [
      {
        paragraphs: [
          <>
            These Terms are governed by the laws of Sweden, without regard to conflict-of-law rules.
            Disputes arising from these Terms or the Service shall be resolved in the courts of
            Sweden, unless mandatory consumer law in your country requires otherwise.
          </>,
        ],
      },
    ],
  },
  {
    title: "12. Changes to terms",
    blocks: [
      {
        paragraphs: [
          <>
            We may update these Terms from time to time. We will post changes on this page and
            update the &quot;Last updated&quot; date. Material changes may also be communicated
            where appropriate. Continued use of the Service after changes take effect constitutes
            acceptance of the updated Terms.
          </>,
        ],
      },
    ],
  },
  {
    title: "13. Severability",
    blocks: [
      {
        paragraphs: [
          <>
            If any provision of these Terms is held invalid or unenforceable, the remaining
            provisions remain in full force and effect, and the invalid provision will be replaced
            with a valid one that most closely reflects the original intent.
          </>,
        ],
      },
    ],
  },
  {
    title: "14. Force majeure",
    blocks: [
      {
        paragraphs: [
          <>
            We are not liable for delays or failures caused by events outside our reasonable
            control, including natural disasters, war, labor disputes, infrastructure outages, or
            failures of third-party services we rely on.
          </>,
        ],
      },
    ],
  },
  {
    title: "15. Contact",
    blocks: [
      {
        paragraphs: [
          <>
            Questions about these Terms? Contact <TermsContactEmail />.
          </>,
        ],
      },
    ],
  },
];
